import { REQUERT_PLANHANDLE_PLANHANDLE_FAILED, GET_DATA_PLANHANDLE_PLANHANDLE_SUCCEEDED } from '../actions/actionTypes'

const planHandleReducer = (DataPlanHandle = [], actions) => {
    switch (actions.type) {
        case GET_DATA_PLANHANDLE_PLANHANDLE_SUCCEEDED:
            if(Object.keys(actions.DataPlanHandle).length > 0)
            {
                return {...DataPlanHandle,DataPlanHandle: actions.DataPlanHandle};
            }
            else
            {
                return {...DataPlanHandle,DataPlanHandle: []};
            }
        case REQUERT_PLANHANDLE_PLANHANDLE_FAILED:
            return {...DataPlanHandle,DataPlanHandle: []};
        default:
            return DataPlanHandle;
    }
}

export default planHandleReducer;